import { useContext, useEffect, useMemo, useRef, useState } from "react"
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { Dropdown } from "primereact/dropdown";
import { callautopopulate } from "../../../services/callautopop";
import { secondsToHours } from "../../../utils/Helper";
import _ from "underscore";
import { ToastContext } from "../../../context/ToastContext";
import { useCommon } from "./useCommon";
import globalFilterStore from "../../../Store/globalFilterStore";
import { useCommon as getPermission } from "../../Common/useCommon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


export const usePlanning = () => {

    const { showSuccess, showError, showInfo } = useContext(ToastContext);
    const { getSubProject } = useCommon();
    const { getValuePermission } = getPermission()
    const [rowData, setRowData] = useState([]);
    const [option, setOption] = useState({});
    const tagRef = useRef(null)
    const [selectedHour, setSelectedHour] = useState(3);
    const [loader, setLoader] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [totalData, setTotalData] = useState(null);
    const [showPopup, setShowPopup] = useState({ show: false });
    const [expanded, setExpanded] = useState(true);
    const [productCode, setProjectCode] = useState(null)
    const store = globalFilterStore();
    const { commonFilter, setCommonFilter, projectWiseData, setProjectWiseData } = store;
    const [filterValues, setFilterValues] = useState({ ...commonFilter });
    const [taskDetailsPopup, setTaskDetailsPopup] = useState({ show: false, hoveredId: 0 });
    const columns = [
        {
            key: "",
            label: "",
            checkbox: true,
            style: { width: "3%" },
            headerStyle: { textAlign: "center" },
            sort: false,
            render: (row, isAll) => {
                return (
                    <div className="d-flex justify-content-center w100">
                        <input type="checkbox" className="input-dd" checked={selectedRows.includes(row?.issue_id) || selectedRows.includes(row?.id)} onChange={() => { handleCheckboxChange(row, isAll); setProjectCode(row?.product_code) }} />
                    </div>
                );
            },

        },
        {
            key: "issue_key",
            label: "Task ID",
            style: { width: "10%", textAlign: "center" },
            headerStyle: { textAlign: "center" },
            render: (row) => {
                const isHovered = taskDetailsPopup?.hoveredId === row?.issue_id;
                return <div className="d-flex justify-content-between align-items-center px-1" onMouseEnter={() => setTaskDetailsPopup((prev) => ({ ...prev, hoveredId: row?.issue_id }))} onMouseLeave={() => setTaskDetailsPopup((prev) => ({ ...prev, hoveredId: 0 }))}>
                    <div className={`d-flex gap-2 align-items-center ${isHovered ? "w90" : "w100"}`} >
                        <img src={row?.issue_type_image_url} alt="" width={16} height={16} />
                        <div className="c-pointer fw-semibold text-decoration-underline text-truncate" onClick={() => setTaskDetailsPopup((prev) => ({ ...prev, show: true, data: row }))} >{row?.issue_key}</div>
                    </div>
                    {isHovered && <a href={row?.issue_url} target="_blank" className="w10 text-secondary"><FontAwesomeIcon icon="fa-solid fa-link" /></a>}
                </div>
            }
        },
        {
            key: "issue_summary",
            label: "Task Name",
            style: { width: "50%", flex: "1" },
            render: (row) => {
                return <div className="text-truncate" title={row?.issue_summary}>{row?.issue_summary}</div>
            }
        },
        {
            key: "complexity_id",
            label: "Complexity",
            hide: !commonFilter.taskType,
            style: { width: "10%", padding: 0 },
            headerStyle: { textAlign: "center" },
            sort: false,
            render: (row) => {
                return (
                    <Dropdown
                        className="input-dd w100 m-0"
                        filter
                        showClear
                        value={row?.complexity_id}
                        placeholder=" "
                        options={option?.complexity}
                        optionLabel="issue_complexity_name"
                        optionValue="issue_complexity_id"
                        onChange={(e) => upsertBucketplanning(row, e.value, "Complexity")}
                        disabled={(row?.estimated_by && option?.userCode !== row?.estimated_by)}
                    />
                );
            }
        },
        {
            key: "longitivity_id",
            label: "Longitivity",
            hide: !commonFilter.taskType,
            style: { width: "10%", padding: 0 },
            headerStyle: { textAlign: "center" },
            sort: false,
            render: (row) => {
                return (
                    <Dropdown
                        className="input-dd w100 m-0"
                        filter
                        showClear
                        value={row?.longitivity_id}
                        placeholder=" "
                        options={option?.logitivity}
                        optionLabel="issue_logitivity_name"
                        optionValue="issue_logitivity_id"
                        onChange={(e) => upsertBucketplanning(row, e.value, "Longitivity")}
                        disabled={(row?.estimated_by && option?.userCode !== row?.estimated_by)}
                    />
                );
            }
        },
        {
            key: "estimate_seconds",
            label: "Lead's Estimate (hrs)",
            hide: !commonFilter.taskType,
            style: { width: "10%", padding: 0 },
            headerStyle: { textAlign: "center" },
            sort: false,
            render: (row) => {
                return (
                    <Dropdown
                        className="input-dd w100 m-0"
                        filter
                        showClear
                        value={row?.estimate_seconds}
                        placeholder=" "
                        options={option?.estimate}
                        optionLabel="label"
                        optionValue="bid_seconds"
                        onChange={(e) => upsertBucketplanning(row, e.value, "Estimate")}
                    />
                );
            }
        },
        {
            key: "assignee",
            label: "Assignee",
            hide: commonFilter.taskType,
            style: { width: "10%", padding: 0 },
            pinned: "right",
            headerStyle: { textAlign: "center" },
            sort: false,
            render: (row) => {
                return (
                    <Dropdown
                        className="input-dd w100 m-0"
                        filter
                        showClear
                        value={row?.assignee_user_code}
                        style={{ width: "100%" }}
                        placeholder=" "
                        options={_.filter(option?.projectUser, { project_id: row?.project_id }) || []}
                        optionLabel="user_display_name"
                        optionValue="user_code"
                        onChange={(e) => upsertBucketplanning(row, e.value, "assignee_user_code")}
                    />
                );
            }
        }, {
            key: "time_matrix",
            label: "Time Matrix",
            style: { width: "7%", textAlign: "center" },
            headerStyle: { textAlign: "center" },
            hide: !commonFilter.taskType || getValuePermission("time_matrix_column"),
            render: (row) => {
                const range = _.find(option?.timeMatrix, (item) => parseInt(item?.complexity_id) === row?.complexity_id && parseInt(item?.longitivity_id) === row?.longitivity_id)
                return (
                    <p className="fw-bold">{range?.min_hours} - {range?.max_hours}</p>
                );
            }
        }
    ];

    useEffect(() => {
        callautopopulate("projects", "issue_complexity", "issue_logitivity", "bid_seconds", "user_info", "time_matrix").then((res) => {
            res?.bid_seconds?.forEach(item => {
                item.label = secondsToHours(item.bid_seconds);
            });
            setOption({
                complexity: _.sortBy(res?.issue_complexity, 'order_number'),
                logitivity: _.sortBy(res?.issue_logitivity, 'order_number'),
                estimate: res?.bid_seconds,
                projects: _.sortBy(res?.projects, "project_name"),
                userCode: res?.user_info[0]?.user_code,
                timeMatrix: res?.time_matrix,
            })
            if (commonFilter?.projects?.length > 0) {
                handleData(res?.user_info[0]?.user_code);
            } else {
                setOption((prev) => ({ ...prev, apiCall: true }));
            }
        })
    }, []);

    useEffect(() => {
        !_.isEqual(commonFilter, filterValues) && setCommonFilter({ ...commonFilter, ...filterValues });
    }, [filterValues])

    useEffect(() => {
        if (!_.isEqual(commonFilter, filterValues)) {
            setFilterValues((prev) => ({ ...prev, ...commonFilter }));
        }
    }, [commonFilter])

    const handleData = async (userCode) => {
        const data = await getSubProject(commonFilter?.projects, ["is_sub_project", "is_issue_type", "is_reporter", "is_sprint"], userCode || option?.userCode);
        if (data) {
            setProjectWiseData(data);
            setOption((prev) => ({ ...prev, apiCall: true }));
        }
    }


    const handleCheckboxChange = (row, isAll = false) => {
        if (isAll) {
            if (selectAll) {
                setSelectedRows([]);
                setSelectAll(false);
            } else {
                const allIds = ["all"];
                rowData.forEach(parent => {
                    if (parent.children && parent.children.length > 0) {
                        parent.children.forEach(child => {
                            allIds.push(child.issue_id);
                        });
                    }
                });
                setSelectedRows(allIds);
                setSelectAll(true);
            }
        } else {
            const rowId = row.issue_id;
            setSelectedRows(prev => {
                if (prev.includes(rowId)) {
                    if (prev.includes("all")) {
                        return prev.filter(id => id !== "all" && id !== rowId);
                    }
                    return prev.filter(id => id !== rowId);
                } else {
                    const newSelection = prev.filter(id => id !== "all");
                    newSelection.push(rowId);
                    return newSelection;
                }
            });
            setSelectAll(false);
        }
    };

    useEffect(() => {
        option?.apiCall && getPlanningDetails()
    }, [option?.apiCall])

    const getPlanningDetails = async () => {
        try {
            setLoader(true);
            const payload = {
                project_ids: commonFilter?.projects?.toString() || "",
                sub_project_ids: commonFilter?.subProject?.toString() || "",
                sprint_ids: commonFilter?.sprint?.toString() || "",
                issuetype_ids: commonFilter?.issueType?.toString() || "",
                issue_keys: commonFilter?.issueKey || "",
                reporter_user_code: commonFilter?.reporters?.toString() || "",
                is_enable_bucket: commonFilter?.taskType
            }
            const res = await services.getInvokeRemote("POST", Urls("PGETBUCKETPLANNINGDETAILS"), payload)
            if (!res?.body?.error_status) {
                const grouped = {};
                setOption((prev) => ({ ...prev, apiCall: false, projectUser: _.sortBy(res?.body?.data?.project_users, "user_display_name"), }))
                setTotalData(res?.body?.data?.planning_data?.length)
                res?.body?.data?.planning_data?.forEach(issue => {
                    const featureKey = issue.feature_issue_key;
                    if (featureKey) {
                        if (!grouped[featureKey]) {
                            grouped[featureKey] = {
                                id: featureKey,
                                title: issue.feature_issue_summary || featureKey,
                                children: []
                            };
                        }
                        grouped[featureKey].children.push(issue);
                    }
                });
                setSelectedRows([])
                setSelectAll(false);
                setRowData(Object.values(grouped))
                setLoader(false);
                setCommonFilter({ ...commonFilter, isChange: false })
            }
        } catch (error) {
            setLoader(false);
            console.error("error:::", error)
        }
    }

    const upsertBucketplanning = async (row, newValue, name) => {
        try {
            const data = selectedRows?.filter(id => id !== "all");
            if (data.length === 0 && name === "bulk") {
                showInfo("info", "Please select an issue");
                return;
            }
            let payload
            if (name === "bulk") {
                let key = []
                if (showPopup.complexity_id) {
                    key.push("Complexity")
                }
                if (showPopup.longitivity_id) {
                    key.push("Longitivity")
                }
                if (showPopup.estimate_seconds) {
                    key.push("Estimate")
                }
                payload = {
                    "issue_ids": data?.toString(),
                    "product_code": productCode,
                    "complexity_id": showPopup.complexity_id || 0,
                    "longitivity_id": showPopup?.longitivity_id || 0,
                    "estimate_seconds": showPopup?.estimate_seconds || 0,
                    "is_bucket_enable": commonFilter?.taskType,
                    "assignee_user_code": 0,
                    "estimate_key": key?.toString() || "",
                }
            } else {
                payload = {
                    "issue_ids": row?.issue_id?.toString(),
                    "product_code": row?.product_code,
                    "complexity_id": name === "Complexity" ? newValue !== undefined ? newValue : 0 : row?.complexity_id || 0,
                    "longitivity_id": name === "Longitivity" ? newValue !== undefined ? newValue : 0 : row?.longitivity_id || 0,
                    "estimate_seconds": name === "Estimate" ? newValue !== undefined ? newValue : 0 : row?.estimate_seconds || 0,
                    "is_bucket_enable": commonFilter?.taskType,
                    "estimate_key": name !== "assignee_user_code" ? name : "",
                    "assignee_user_code": name === "assignee_user_code" ? newValue !== undefined ? newValue : 0 : row?.assignee_user_code || 0
                }
            }
            const res = await services.getInvokeRemote("POST", Urls("PUPSERTBUCKETPLANNINGSAVE"), payload)
            if (!res?.body?.error_status) {
                showSuccess('Success', res.body.message);
                if (name === "bulk") {
                    setShowPopup({ show: false })
                    getPlanningDetails()
                } else {
                    setRowData(prevData => {
                        return prevData.map(parent => ({
                            ...parent,
                            children: parent.children.map(child =>
                                child.issue_id === row.issue_id
                                    ? {
                                        ...child,
                                        ...(name === "Complexity" && { complexity_id: newValue }),
                                        ...(name === "Longitivity" && { longitivity_id: newValue }),
                                        ...(name === "Estimate" && { estimate_seconds: newValue }),
                                        ...(name === "assignee_user_code" && { assignee_user_code: newValue })
                                    }
                                    : child
                            )
                        }));
                    });
                }

            } else {
                showError("error", res?.body?.errorMessage);
            }
        } catch (error) {
            showError("error", error?.response?.data?.errorMessage)
        }
    }

    const handleSendToEstimate = async () => {
        const data = selectedRows?.filter(id => id !== "all");
        if (data.length === 0) {
            showInfo("info", "Please select an issue");
            return;
        }
        const invalidIssues = [];
        rowData.forEach(parent => {
            if (parent.children && parent.children.length > 0) {
                parent.children.forEach(child => {
                    if ((!child.complexity_id || !child.longitivity_id) && data?.includes(child?.issue_id) && commonFilter?.taskType) {
                        invalidIssues.push(child.issue_key);
                    }
                    if ((!child.assignee_user_code) && data?.includes(child?.issue_id) && !commonFilter?.taskType) {
                        invalidIssues.push(child.issue_key);
                    }
                });
            }
        });
        if (invalidIssues.length > 0 && commonFilter?.taskType) {
            showInfo('Info', `Complexity or Longivity Should not be Empty`);
            return;
        }

        if (invalidIssues.length > 0 && !commonFilter?.taskType) {
            showInfo('Info', `Assignee Should not be Empty`);
            return;
        }
        const payload = {
            "estimate_seconds": commonFilter?.taskType ? selectedHour * 3600 : 0,
            "issue_ids": data?.toString() || "",
            "is_bucket_enable": commonFilter?.taskType
        }
        const res = await services.getInvokeRemote("POST", Urls("UPSERTSENDBUCKETESTIMATESAVE"), payload);
        if (res?.StatusCode === 202 || res?.status === 202) {
            showError("Error", res.body.errorMessage);
        } else if (res.body.data) {
            showSuccess('Success', res.body.message);
            if (commonFilter?.taskType) {
                getPlanningDetails()
            } else {
                setLoader(true);
                setTimeout(() => {
                    getPlanningDetails()
                }, 3000);
            }

        } else {
            showError('Error', res?.body.errorMessage);
        }
    }


    return useMemo(() => ({
        columns, rowData, option, setOption, selectedHour, setSelectedHour, getPlanningDetails, handleSendToEstimate, tagRef, loader, handleData, projectWiseData, totalData, showPopup, setShowPopup, upsertBucketplanning, selectedRows, showInfo, setCommonFilter, commonFilter, expanded, setExpanded, filterValues, setFilterValues, taskDetailsPopup, setTaskDetailsPopup
    }), [columns, rowData, option, setOption, selectedHour, setSelectedHour, getPlanningDetails, handleSendToEstimate, tagRef, loader, handleData, projectWiseData, totalData, showPopup, setShowPopup, upsertBucketplanning, selectedRows, showInfo, setCommonFilter, commonFilter, expanded, setExpanded, filterValues, setFilterValues, taskDetailsPopup, setTaskDetailsPopup])
}